/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetContactSettingsResponseData,
  GetContactSettingsResponseDataFromJSON,
  GetContactSettingsResponseDataFromJSONTyped,
  GetContactSettingsResponseDataToJSON
} from './GetContactSettingsResponseData'

/**
 *
 * @export
 * @interface GetContactSettingsResponse
 */
export interface GetContactSettingsResponse {
  /**
   *
   * @type {number}
   * @memberof GetContactSettingsResponse
   */
  status?: number
  /**
   *
   * @type {GetContactSettingsResponseData}
   * @memberof GetContactSettingsResponse
   */
  data?: GetContactSettingsResponseData
}

export function GetContactSettingsResponseFromJSON(json: any): GetContactSettingsResponse {
  return GetContactSettingsResponseFromJSONTyped(json, false)
}

export function GetContactSettingsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetContactSettingsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetContactSettingsResponseDataFromJSON(json['data'])
  }
}

export function GetContactSettingsResponseToJSON(value?: GetContactSettingsResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetContactSettingsResponseDataToJSON(value.data)
  }
}
